module.exports = __webpack_public_path__ + "static/media/person-delete-outline.8347a727.svg";